import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    document.arrive('.block-financial-files-list', {existing: true}, function () {
        let $block = $(this);
        $block.find('.financial-filters select').change({block: $block}, function (e) {
            e.stopPropagation();
            e.preventDefault();
            let query_vars = {
                post_type: 'financial',
                post_status: 'publish',
                posts_per_page: 1000,
                tax_query: {
                    0: {
                        taxonomy: 'category_financials',
                        field: 'term_taxonomy_id',
                        terms: $(this).data('taxonomy-term-id')
                    }
                },
                orderby: 'date',
                orderway: 'DESC',
            };
            let year = parseInt($(this).val());
            if (year) {
                query_vars['date_query'] = {
                    0: {
                        'year': year,
                        compare: '='
                    }
                }
            }
            let loader = e.data.block.find('.srg-loader');
            $.ajax({
                url: srg.ajaxurl,
                type: 'post',
                data: {
                    action: 'get_financials',
                    query_vars: JSON.stringify(query_vars),
                },
                success: function (results) {
                    loader.show();
                    e.data.block.find('.srg-slick-files-slider').replaceWith(results);
                    loader.hide();
                }
            });
        });
        if($(window).width() < 992){
            $block.find('.block-financial-files-list-container .srg-title').each(function() {
                let $title = $(this);
                $title.click(function() {
                    $block.find('.srg-files-list').slideToggle();
                    let $parent = $title.parent();
                    if ($parent.hasClass('active')) {
                        $parent.removeClass('active');
                        if($block.prev('.block-financial-files-list').length){
                            $('html, body').animate({
                                scrollTop: $block.prev('.block-financial-files-list').offset().top - 50
                            }, 300);
                        }
                    } else {
                        $('.block-financial-files-list .srg-posts-list-content-container-left.active .srg-title').click();
                        $parent.addClass('active');
                        $('html, body').animate({
                            scrollTop: $parent.offset().top - 50
                        }, 300);
                    }
                })
            })
        }
    });
});
